// == Import npm
import React, { useEffect } from "react";
import { Button, Modal, Typography } from "antd";

// == Import SCSS
import "./modalStatus.less";

// == Import components

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { updatePrinterStatus } from "services/features/VisitsSlice";

const ModalError = ({ isVisible, onClose }) => {
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const { printer } = useSelector(state => state.visits);
  const { isError, ipAddress, connexion, name, error, pause, offline, paperOut } = printer;

  useEffect(() => {
    if (isVisible) dispatch(updatePrinterStatus());
  }, [isVisible, dispatch]);

  return (
    <div>
      <Modal
        className="modalStatus"
        width="700px"
        open={isVisible}
        onOk={onClose}
        onCancel={onClose}
        footer={
          <>
            <Button
              type="primary"
              style={{ width: "150px" }}
              size="large"
              className="modalError__modal__yes"
              onClick={onClose}
            >
              {t("Close")}
            </Button>
          </>
        }
      >
        <div className="modalStatus__modal__text">
          <Typography.Title>{t("PrinterStatus")}</Typography.Title>
          <Typography.Paragraph
            style={{
              fontSize: "14px",
              margin: "10px 0 0 20px",
              overflowWrap: "breack-word",
            }}
          >
            <div className="modalStatus__parameter">
              <div className="modalStatus__label">{t("State")}</div>
              <div className="modalStatus__separator">:</div>
              <div className="modalStatus__value">{isError ? t("ErrorStatus") : t("OK")}</div>
            </div>
            {isError ? (
              <>
                <div className="modalStatus__parameter">
                  <div className="modalStatus__label">{t("Error")}</div>
                  <div className="modalStatus__separator">:</div>
                  <div className="modalStatus__value">{error}</div>
                </div>
              </>
            ) : (
              <>
                <div className="modalStatus__parameter">
                  <div className="modalStatus__label">{t("Name")}</div>
                  <div className="modalStatus__separator">:</div>
                  <div className="modalStatus__value">{name}</div>
                </div>
                <div className="modalStatus__parameter">
                  <div className="modalStatus__label">{t("IpAddress")}</div>
                  <div className="modalStatus__separator">:</div>
                  <div className="modalStatus__value">{ipAddress}</div>
                </div>
                <div className="modalStatus__parameter">
                  <div className="modalStatus__label">{t("ConnexionType")}</div>
                  <div className="modalStatus__separator">:</div>
                  <div className="modalStatus__value">{connexion}</div>
                </div>
                <div className="modalStatus__parameter">
                  <div className="modalStatus__label">{t("Online")}</div>
                  <div className="modalStatus__separator">:</div>
                  <div className="modalStatus__value">{offline ? t("No") : t("Yes")}</div>
                </div>
                <div className="modalStatus__parameter">
                  <div className="modalStatus__label">{t("Pause")}</div>
                  <div className="modalStatus__separator">:</div>
                  <div className="modalStatus__value">{pause ? t("Yes") : t("No")}</div>
                </div>
                <div className="modalStatus__parameter">
                  <div className="modalStatus__label">{t("PaperOut")}</div>
                  <div className="modalStatus__separator">:</div>
                  <div className="modalStatus__value">{paperOut ? t("Yes") : t("No")}</div>
                </div>
              </>
            )}
          </Typography.Paragraph>
        </div>
      </Modal>
    </div>
  );
};

export default ModalError;
